import { atom } from "recoil";

export const promotionAddModalStore = atom({
	key: "promotionAddModalStore",
	default: {
		show: false,
		loaded: false,
		currentOption: {
			type: [{value: "fiat", label: "fiat"}, {value: "crypto", label: "crypto",}],
		},
		type: "",
		typePromo: "",
		fromAmount: false,
		toAmount: false,
		startDate: "",
		endDate: "",
		percent: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
